export const tooltipDescriptions = {
	liabilityAmount: 'This protects you in case\n' +
		'\t\t\t\t\tyou cause damage to your home or neighboring property because of smoke, fire, water and explosion.\n' +
		'\t\t\t\t\tAnd, if a guest gets hurt or bitten by your dog, we\'ll cover necessary medical and legal expenses up\n' +
		'\t\t\t\t\tto the amount you choose below.',
	'deductible': 'A deductible is a lump sum you have to pay upfront, but with us, we\'ll subtract it from your claim\n' +
		'\t\t\t\t\tpayout.\n' +
		'\t\t\t\t\tA higher deductible will lower your monthly payment, but also means you\'ll receive less for a\n' +
		'\t\t\t\t\tcovered loss.\n' +
		'\t\t\t\t\tFor example, if you choose a $250 deductible and you have a table worth $800, we\'ll give you $550\n' +
		'\t\t\t\t\tback.',
	'floodIncluded': 'Coverage includes up to $2,500 for your belongings damaged by a flood,\n' +
		'\t\t\t\t\t\t\tup to $1,000 for additional living expenses if you need to stay somewhere else,\n' +
		'\t\t\t\t\t\t\tand up to $100 for food spoiled during extended power outages.',
	'petDamage': 'Pet Damage – Coverage includes up to $500 to repair damages to your home caused by pets.',
	'waterDamageLiability': 'Covers accidental water damage to your home\n' +
		'\t\t\t\t\t\t\t\t(e.g., due to tub overflows or setting off a sprinkler system) up to the liability amount chosen.',
	'personalPropertyAmount': 'How much would it cost to\n' +
		'\t\t\t\t\treplace your belongings (e.g., furniture, clothes, electronics)? Select your coverage based on your\n' +
		'\t\t\t\t\tanswer. The amount you choose can cover a roommate\'s belongings, too. Just be sure to add them to\n' +
		'\t\t\t\t\tyour policy at checkout. Move the slider or enter an amount to choose as much or as little coverage\n' +
		'\t\t\t\t\tas you need.',
	'replacementCost': 'Coverage includes reimbursement for the actual cost of replacing belongings.',
	'waterBackup': (state: string)  => {
		return state === 'NC'
			? `Coverage includes up to $5,000 in damages if a sewer or drain backs up into your home.  
									A $350 deductible applies`
			: `Coverage includes up to $2,500 in damages if a sewer or drain backs up into your home. 
									A $250 deductible applies.`
	},
	'earthquake': 'Coverage includes up to the amount you chose for your belongings and additional living\n' +
		'\t\t\t\t\t\t\t\texpenses if you need\n' +
		'\t\t\t\t\t\t\t\tto stay somewhere else. A deductible applies.',
	'identityFraud': 'Identity fraud expense coverage includes up to $15,000 for your expenses\n' +
		'\t\t\t\t\t\t\t\tif you’re a victim of identify fraud. A $100 deductible applies.',
};

export const getTooltipDescription = (
	key: keyof typeof tooltipDescriptions,
	state?: string
): string => {
	const description = tooltipDescriptions[key];

	if (typeof description === 'function') {
		return description(state ?? '');
	}

	return description;
};
